import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";

export default function DeleteConfirmationDialog({ title, content, open, onClose, onConfirm }: { title: string, content: string, open: boolean, onClose: () => void, onConfirm: () => void }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      slotProps={{ paper: { sx: { p: 3 } } }}
    >
      <DialogTitle id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button variant="outlined" sx={{ borderColor: 'rgba(0, 0, 0, 0.12)', color: 'text.secondary' }} onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="error" onClick={onConfirm} autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}